module.exports = __webpack_public_path__ + "img/hero-mobile.af01bee4.webp";